<template>
    <div class="App">
        <router-view></router-view>
    </div>
</template>

<script>
    export default {
        name: "App",
        props: {},
        data () {
            return {};
        },
        computed: {},
        created () {
            this.$Message.config({
                top: 50,
                duration: 5
            });
            // console.log(this.$getFieldPermissonMap());
        },
        methods: {}
    };
</script>

<style lang="less" scoped>
    .App {
        width: 100%;
        height: 100%;
        overflow: hidden;
    }
</style>



// WEBPACK FOOTER //
// src/App.vue